module.exports = __webpack_public_path__ + "img/close-24px.b840e171.svg";